<script lang="ts">
	import type { InputCheckboxProps } from '../types';
	import Input from '../Input.svelte';
	import Icon from '../../Icon.svelte';
	import Hint from '../../Hint.svelte';
	import DynamicComponent from '$lib/components/DynamicComponent.svelte';

	export let props: InputCheckboxProps;

	$: props.key = props.key ?? 'checkbox';

	let isErrorDisplayed;

	const handleChange = () => {
		if (!props.touched) {
			props.touched = true;
		}
		if (!props.dirty) {
			props.dirty = true;
		}
	};
</script>

<div>
	<Input bind:props bind:isErrorDisplayed isLabelHidden={true}>
		<label
			for={props.id}
			class:cursor-not-allowed={props.disabled}
			class:cursor-pointer={!props.disabled}
			class="inline-flex"
		>
			<input
				required={props.required}
				disabled={props.disabled}
				id={props.id}
				type="checkbox"
				class="custom-checkbox mt-1"
				class:cursor-pointer={!props.disabled}
				bind:checked={props.checked}
				bind:this={props.ref}
				on:change|once={() => handleChange()}
				on:change
			/>
			{#if props.icon}
				<Icon classNames="ml-2" name={props.icon} />
			{/if}
			{#if props.label}
				<span class="ml-2 first-letter:uppercase" class:font-bold={props.boldLabel}>
					{#if props.label.component}
						<DynamicComponent component={props.label} />
					{:else if typeof props.label == 'string'}
						{@html props.label}
					{:else}
						<DynamicComponent component={props.label} />
					{/if}
					{#if props.required}
						<span class="text-primary">*</span>
					{/if}
				</span>
			{/if}
			{#if props.hint}
				<div class="ml-2 inline-flex items-center">
					<Hint tooltip={{ title: props.hint }} />
				</div>
			{/if}
		</label>
	</Input>
</div>

<style lang="postcss">
	.custom-checkbox {
		@apply inline-block box-border align-middle text-primary
    flex-shrink-0 w-3 h-3 p-0 bg-white appearance-none border rounded-sm
    border-grey ring-0 focus:ring-0 focus:ring-transparent;
		background-origin: border-box;
	}

	.custom-checkbox:checked {
		@apply border-transparent bg-primary bg-center bg-no-repeat;
		background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
		background-size: 100% 100%;
	}

	.custom-checkbox:disabled {
		@apply border-grey-lighter cursor-not-allowed;
	}
</style>
